import React from 'react';
import { Calendar, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { Badge } from './Badge';
interface TripCardProps {
  id: string;
  itemTitle: string;
  itemImage: string;
  startDate: string;
  endDate: string;
  status: 'pending' | 'approved' | 'active' | 'completed' | 'disputed' | 'returned';
  location: string;
  onClick: () => void;
  onAction?: () => void;
  actionLabel?: string;
}
export function TripCard({
  itemTitle,
  itemImage,
  startDate,
  endDate,
  status,
  location,
  onClick,
  onAction,
  actionLabel
}: TripCardProps) {
  const statusConfig = {
    pending: {
      label: 'Pending',
      variant: 'warning' as const
    },
    approved: {
      label: 'Approved',
      variant: 'success' as const
    },
    active: {
      label: 'Active',
      variant: 'primary' as const
    },
    completed: {
      label: 'Completed',
      variant: 'neutral' as const
    },
    disputed: {
      label: 'Disputed',
      variant: 'warning' as const
    },
    returned: {
      label: 'Item Returned',
      variant: 'secondary' as const
    }
  };
  return <motion.div whileTap={{
    scale: 0.98
  }} className="w-full bg-white border border-sand rounded-lg overflow-hidden active:shadow-none transition-shadow text-left" data-id="element-496">
      <button onClick={onClick} className="w-full text-left" data-id="element-497">
        <div className="flex gap-2 p-3 relative" data-id="element-498">
          <img src={itemImage} alt={itemTitle} className="w-20 h-20 rounded-md object-cover flex-shrink-0" data-id="element-499" />
          <div className="flex-1 min-w-0 pr-16" data-id="element-500">
            <h3 className="text-[13px] font-bold text-charcoal line-clamp-1" data-id="element-501">
              {itemTitle}
            </h3>
            <div className="mt-1 space-y-0.5" data-id="element-502">
              <div className="flex items-center gap-1 text-[11px] text-moss-gray" data-id="element-503">
                <Calendar size={12} data-id="element-504" />
                <span data-id="element-505">
                  {startDate} - {endDate}
                </span>
              </div>
              <div className="flex items-center gap-1 text-[11px] text-moss-gray" data-id="element-506">
                <MapPin size={12} data-id="element-507" />
                <span data-id="element-508">{location}</span>
              </div>
            </div>
          </div>

          {/* Status Badge - Top Right */}
          <div className="absolute top-3 right-3" data-id="element-509">
            <Badge variant={statusConfig[status].variant} size="sm" data-id="element-510">
              {statusConfig[status].label}
            </Badge>
          </div>
        </div>
      </button>

      {/* Action Button - Bottom Right */}
      {onAction && actionLabel && <div className="flex justify-end px-3 pb-3 -mt-1" data-id="element-511">
          <button onClick={e => {
        e.stopPropagation();
        onAction();
      }} className="px-4 py-1.5 bg-dark-green text-white text-[11px] font-bold rounded hover:bg-dark-green/90 active:scale-95 transition-all min-w-[100px] h-8 flex items-center justify-center" data-id="element-512">
            {actionLabel}
          </button>
        </div>}
    </motion.div>;
}